export default __webpack_public_path__ + "static/media/money.fea13247.svg";